import { configureStore } from "@reduxjs/toolkit";

import createRootReducer from ".";
import { appConfigMiddleware } from "../middleware/AppConfigs";

function configureAppStore() {
  return configureStore({
    reducer: createRootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(appConfigMiddleware),
  });
}

export default configureAppStore;
